<template>
  <div v-loading="loading" :class="[$style.loginWrap]">
    <AccountNav></AccountNav>
    <form
      v-if="loggedIn && $route.query.dashboard_type === 'brokerage'"
      :class="[$style.inputForm]"
      @submit.prevent="handleSelectBrokerage"
    >
      <el-select
        v-model="s_brokerage_seq"
        :class="[$style.inputLogin]"
        :placeholder="$t('login_me.select_an_intermediary')"
      >
        <el-option
          v-for="item in brokerages"
          :key="item.seq"
          :label="item.title"
          :value="item.seq"
        >
        </el-option>
      </el-select>
      <el-button
        :class="[$style.loginButton, 'active']"
        native-type="submit"
        round
      >
        {{ $t('login_me.shortcuts') }}
      </el-button>
    </form>
    <form v-else :class="[$style.inputForm]" @submit.prevent="handleLogin">
      <template v-if="!otp_token_required">
        <el-input
          v-model="username"
          prefix-icon="el-icon-user"
          :class="[$style.inputLogin]"
          :placeholder="$t('account_form.id_place')"
        />
        <el-input
          v-model="password"
          prefix-icon="el-icon-lock"
          :class="[$style.inputLogin]"
          :placeholder="$t('account_form.pw_place')"
          type="password"
        />
      </template>
      <el-input
        v-else
        v-model="otp_token"
        prefix-icon="el-icon-lock"
        :class="[$style.inputLogin]"
        :placeholder="$t('otp.enter_verification_number')"
      />
      <p :class="[$style.findWrap]">
        <router-link
          :to="{ name: 'account-find' }"
          :class="[$style.loginLink]"
          >{{ $t('account_form.forgot_pw') }}</router-link
        >
      </p>
      <el-button
        :class="[$style.loginButton, { active: otp_token_required !== true }]"
        native-type="submit"
        round
      >
        {{ $t('login') }}
      </el-button>
      <el-button
        v-if="otp_token_required"
        class="back-btn"
        :class="[$style.loginButton]"
        round
        @click.prevent="handleCancel"
      >
        {{ $t('login_me.back') }}
      </el-button>
    </form>
  </div>
</template>
<script>
import { authMethods, authComputed } from '@state/helpers'
import { mapState } from 'vuex'
import AccountNav from '@components/AccountNav'
export default {
  components: { AccountNav },
  data() {
    return {
      username: '',
      password: '',
      otp_token: '',
      s_brokerage_seq: null,
      loading: false,
      otp_token_required: false,
    }
  },
  computed: {
    ...authComputed,
    ...mapState('brokerage', ['brokerages']),
  },
  methods: {
    ...authMethods,
    async handleSelectBrokerage() {
      if (!this.s_brokerage_seq) return

      this.$router.push(
        this.$route.query.redirectFrom || {
          name: 'brokerage-console-index',
          params: { brokerage_seq: this.s_brokerage_seq },
        }
      )
    },
    async handleLogin() {
      this.loading = true
      try {
        const { otp_token_required } =
          (await this.logIn({
            username: this.username,
            password: this.password,
            otp_token: this.otp_token,
          })) || {}

        if (otp_token_required) {
          this.otp_token_required = true
          return
        }

        if (this.$route.query.dashboard_type !== 'brokerage')
          this.$router.push(
            this.$route.query.redirectFrom || { name: 'admin-index' }
          )
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    handleCancel() {
      this.username = ''
      this.password = ''
      this.otp_token = ''
      this.otp_token_required = false
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.loginWrap {
  box-sizing: border-box;
  max-width: 500px;
  margin: 0 auto;
  margin-top: 100px;
  margin-bottom: 100px;
  background-color: white;
  border: 1px solid #eee;
  box-shadow: 2px 2px 4px #dee1e7;
}
.loginTitle {
  padding: 12px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  background: #713b87;
}
.inputForm {
  padding: 20px;
}
.inputLogin {
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 50px;
  transition: box-shadow 0.1s ease, -webkit-box-shadow 0.1s ease;
}
.findWrap {
  margin-bottom: 5px;
  text-align: right;
}
.loginLink {
  margin-right: 10px;
  margin-bottom: 30px;
  font-size: 12px;
  color: #a2abc2;
  text-decoration: underline;
  cursor: pointer;
}

.loginButton {
  width: 49%;
  height: 40px;
  margin: 10px 0 0 0 !important;
  font-size: 16px;
  color: #fff !important;
  cursor: pointer;
  background: #63bc90;
  border-radius: 4px !important;
  transition: transform 0.4s ease-out;
}
</style>

<style scoped>
.el-button.is-round:hover,
.el-button.is-round:focus {
  background-color: #4eaa7c;
}
.back-btn:focus,
.back-btn:hover {
  background: #eee !important;
}
.back-btn {
  margin-left: 2% !important;
  color: #999 !important;
  background-color: #e3e3e3 !important;
  border: 1px solid #dcdcdc;
}
.active {
  width: 100%;
}

@media (max-width: 768px) {
  .el-button.is-round {
    width: 100%;
  }
  .back-btn {
    margin-left: 0 !important;
  }
}
</style>
